<rt-icon-button variant="plain" iconName="ai-vision" size="small" (click)="toggle()" />
